<!-- Header -->
<div
  class="hidden rounded-xl bg-white py-4 px-6 z-10 w-full justify-between items-center md:flex"
>
  <div class="font-bold text-xl">{{ 'notification-form.new' | translate }}</div>
  <rk-button
    [icon]="'close'"
    variant="border-grey"
    [iconOnly]="true"
    (buttonClick)="onCloseClick()"
  ></rk-button>
</div>
